var render, staticRenderFns
import script from "./inspection_center.vue?vue&type=script&lang=js"
export * from "./inspection_center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace92368')) {
      api.createRecord('ace92368', component.options)
    } else {
      api.reload('ace92368', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/activity/inspection_center/inspection_center.vue"
export default component.exports